import type { SVGProps } from 'react';

const SvgClassB = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26668)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#D19510'
      />
      <path
        d='M13.2856 13.1142H11.9999C11.3846 13.1142 10.8857 12.6153 10.8857 12.0001C10.8857 11.3848 11.3846 10.8859 11.9999 10.8859H13.2856C13.8527 10.8859 14.3144 10.4243 14.3144 9.85717C14.3144 9.29005 13.8527 8.8284 13.2856 8.8284H9.68534V12.0001C9.68534 12.6154 9.18644 13.1143 8.57118 13.1143C7.95593 13.1143 7.45703 12.6154 7.45703 12.0001V7.71425C7.45703 7.09899 7.95593 6.6001 8.57118 6.6001H13.2856C15.0816 6.6001 16.5427 8.06122 16.5427 9.85718C16.5427 11.6531 15.0816 13.1142 13.2856 13.1142Z'
        fill='white'
      />
      <path
        d='M13.2856 17.4001H8.57118C7.95593 17.4001 7.45703 16.9012 7.45703 16.286V12.0001C7.45703 11.3849 7.95593 10.886 8.57118 10.886C9.18644 10.886 9.68534 11.3849 9.68534 12.0001V15.1718H13.2856C13.8527 15.1718 14.3144 14.7102 14.3144 14.1431C14.3144 13.5759 13.8527 13.1143 13.2856 13.1143H11.9999C11.3846 13.1143 10.8857 12.6154 10.8857 12.0001C10.8857 11.3849 11.3846 10.886 11.9999 10.886H13.2856C15.0816 10.886 16.5427 12.3471 16.5427 14.1431C16.5427 15.939 15.0816 17.4001 13.2856 17.4001Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26668'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassB;
